export function calculateIntentDiversity(
  intentValues: Record<string, number>,
): number {
  const values = Object.values(intentValues);
  const min = Math.min(...values);
  const max = Math.max(...values);

  // Normalize values to a 0–1 range
  const normalizedValues = values.map(
    (value) => (value - min) / (max - min || 1),
  );

  // Calculate mean of normalized values
  const mean =
    normalizedValues.reduce((sum, value) => sum + value, 0) /
    normalizedValues.length;

  // Calculate standard deviation of normalized values to measure diversity
  const stdDev = Math.sqrt(
    normalizedValues.reduce(
      (sum, value) => sum + Math.pow(value - mean, 2),
      0,
    ) / normalizedValues.length,
  );

  // Scale standard deviation to a 0–100 range as a measure of intent diversity
  return Math.min(1, stdDev);
}
